import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
import { maxLength, minLength, numeric, required } from 'vuelidate/lib/validators';
export default {
  name: 'Manager',
  props: {
    value: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      error: false,
      errorMsg: null,
      passcode: null
    };
  },
  computed: {
    settingsPasscode: get('settings/passcode')
  },
  methods: {
    done: function done() {
      this.passcode = null;
      this.$emit('done', {
        name: 'manager',
        result: false
      });
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Check passcode
                Logger.debug('Check passcode'); // Invalid passcode

                if (!(_this.passcode !== _this.settingsPasscode)) {
                  _context.next = 6;
                  break;
                }

                Logger.debug('Invalid passcode');
                _this.error = true;
                _this.errorMsg = _this.$t('staff.errorInvalidPasscode');
                return _context.abrupt("return");

              case 6:
                // Valid passcode
                Logger.debug('Valid passcode');

                _this.$emit('done', {
                  name: 'manager',
                  result: true
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  validations: {
    passcode: {
      maxLength: maxLength(5),
      minLength: minLength(3),
      numeric: numeric,
      required: required
    },
    validationGroup: ['passcode']
  }
};